import { defaultColumnDefinition } from '../../../shared/columnDefinitions';

const columnDefinitions = [
  {
    ...defaultColumnDefinition,
    headerName: 'Row',
    field: 'rowNumber',
    width: 90,
    minWidth: 90,
    sortable: true,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Org Id',
    field: 'orgId',
    flex: 1,
    minWidth: 120,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Account Id',
    field: 'accountId',
    flex: 1,
    minWidth: 120,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Jurisdiction Id',
    field: 'jurisdictionId',
    flex: 1,
    minWidth: 130,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Beg End Flag',
    field: 'begEndFlag',
    flex: 1,
    minWidth: 120,
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Amount',
    field: 'amount',
    flex: 1,
    minWidth: 120,
    headerClass: 'import-grid__header--right',
    cellStyle: {
      textAlign: 'right',
    },
  },
  {
    ...defaultColumnDefinition,
    headerName: 'Error',
    field: 'errorMessage',
    flex: 2,
    minWidth: 180,
    sortable: true,
    headerClass: 'import-grid__header--center',
    cellStyle: {
      textAlign: 'center',
    },
  },
];

export { columnDefinitions };
